import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@/pages/ai-consultation/store/useAIDiagnoseStore';

interface TWeightLossStore {
  showType: 'all' | keyof GetLastMeasurementResponse;
}

const initialStoreValue = {
  showType: 'all' as TWeightLossStore['showType'],
};

export const useWeightLossStore = createSelectors(
  create(
    devtools<TWeightLossStore>(() => initialStoreValue, {
      name: 'weight-loss',
    })
  )
);

export const setShowType = (payload: TWeightLossStore['showType']) =>
  useWeightLossStore.setState(() => ({ showType: payload }));

export const resetWeightLossStore = () => {
  useWeightLossStore.setState(initialStoreValue);
};
